import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Pagination = ({ 
  currentPage, 
  totalPages, 
  totalEntries, 
  limit, 
  onPageChange, 
  onLimitChange 
}) => {
  const [pageInput, setPageInput] = useState(currentPage);

  useEffect(() => {
    setPageInput(currentPage);
  }, [currentPage]);

  const handlePageInputChange = (e) => {
    const val = e.target.value;
    if (val === "") {
      setPageInput("");
      return;
    }
    if (/^\d+$/.test(val)) {
      setPageInput(val);
    }
  };

  const handlePageInputBlur = () => {
    if (pageInput === "" || isNaN(parseInt(pageInput))) {
      setPageInput(currentPage);
      return;
    }
    let numVal = parseInt(pageInput);
    const clampedVal = Math.max(1, Math.min(numVal, totalPages));
    if (clampedVal !== currentPage) {
      onPageChange(clampedVal);
    }
    setPageInput(clampedVal);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handlePageInputBlur();
    }
  };

  return (
    <div className="pagination-container p-3 bg-light d-flex flex-wrap justify-content-between align-items-center gap-3">
      <div className="d-flex align-items-center gap-3">
        <div className="text-muted small fw-bold">
          Total: {totalEntries} entries
        </div>
        <div className="d-flex align-items-center gap-2 ms-3">
          <span className="text-muted small fw-bold">Rows per page:</span>
          <select 
            className="form-select form-select-sm" 
            style={{ width: '80px', height: '31px' }}
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>

      <div className="d-flex align-items-center gap-3">
        <button
          className="btn btn-outline-secondary btn-sm border-0"
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage <= 1}
        >
          <FaChevronLeft />
        </button>

        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            className="form-control form-control-sm text-center fw-bold text-primary border-primary"
            style={{ width: "60px", height: "31px" }}
            value={pageInput}
            onChange={handlePageInputChange}
            onBlur={handlePageInputBlur}
            onKeyDown={handleKeyDown}
          />
          <span className="text-muted fw-bold">/ {totalPages}</span>
        </div>

        <button
          className="btn btn-outline-secondary btn-sm border-0"
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage >= totalPages}
        >
          <FaChevronRight />
        </button>
      </div>
      <style>{`
        .pagination-container .form-control:focus, 
        .pagination-container .form-select:focus {
          border-color: #0d6efd;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
        .pagination-container .btn-outline-secondary:hover {
          background-color: #f8f9fa;
          color: #6c757d;
        }
        .pagination-container input[type=number]::-webkit-inner-spin-button, 
        .pagination-container input[type=number]::-webkit-outer-spin-button { 
          -webkit-appearance: none; 
          margin: 0; 
        }
      `}</style>
    </div>
  );
};

export default Pagination;
